import { NextPage } from 'next';
import { AcceptOfferBackwardsCompatibilityInterceptor } from './AcceptOfferBackwardsCompatibilityInterceptor';

interface AcceptBuyBackwardsCompatibilityInterceptorProps {
  searchParams: Promise<Record<string, string>>;
}

const AcceptBuyBackwardsCompatibilityInterceptor: NextPage<
  AcceptBuyBackwardsCompatibilityInterceptorProps
> = async ({ searchParams }) => {
  const { tradeOfferID } = await searchParams;

  return (
    <AcceptOfferBackwardsCompatibilityInterceptor
      operation="buy"
      tradeOfferID={tradeOfferID}
    />
  );
};

export { AcceptBuyBackwardsCompatibilityInterceptor };
